import { ClearOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select, Space } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { FC } from 'react'
import User from '../../../../components/form-items/user/user'
import { TaskStatuses } from '../../../../types/api/task'

const TASK_STATUS_OPTIONS: { value: TaskStatuses; label: TaskStatuses }[] = [
    { value: 'Новая', label: 'Новая' },
    { value: 'В работе', label: 'В работе' },
    { value: 'Завершена', label: 'Завершена' },
    { value: 'Отменена', label: 'Отменена' },
]

interface FilterFormProps {
    form: FormInstance
    onSearch: () => void
    onClear: () => void
}

const FilterForm: FC<FilterFormProps> = ({ form, onSearch, onClear }) => {
    return (
        <Form form={form} component={false} onFieldsChange={onSearch}>
            <Space wrap>
                <Form.Item name='taskStatus' noStyle>
                    <Select allowClear placeholder='Статус' options={TASK_STATUS_OPTIONS} />
                </Form.Item>
                <Form.Item name='shipmentId' noStyle>
                    <Input placeholder='№ отгрузки' allowClear style={{ width: 120 }} />
                </Form.Item>
                <User
                    name='manager'
                    noStyle
                    rules={[]}
                    placeholder='Менеджер'
                    positions={['Менеджер', 'Помощник менеджера']}
                />
                <Button icon={<ClearOutlined />} title='Сбросить фильтры' onClick={onClear}>
                    Сброс
                </Button>
            </Space>
        </Form>
    )
}

export default FilterForm
